import { useState } from 'react';
import { createPortal } from 'react-dom';

export function BottomModal({ children, isOpen, onClose }) {
  const [isClosing, setIsClosing] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientY);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const minSwipeDistance = 100;

    // Свайп вниз для закрытия
    if (distance < -minSwipeDistance) {
      handleClose();
    }

    setTouchStart(0);
    setTouchEnd(0);
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  if (!isOpen) return null;

  return createPortal(
    <div
      data-bottom-modal-root="true"
      className={`fixed inset-0 z-50 flex items-end justify-center transition-opacity duration-300 ${
        isClosing ? 'opacity-0' : 'opacity-100'
      }`}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        className={`w-full bg-[#043939] rounded-t-[24px] shadow-2xl transform transition-all duration-300 ease-out max-h-[85vh] flex flex-col ${
          isClosing ? 'translate-y-full' : 'translate-y-0'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="relative flex justify-center w-full pt-4 flex-shrink-0 cursor-pointer pb-6"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          style={{ touchAction: 'none' }}
        >
          <div className="w-[80px] h-[5px] bg-[#0B6666] rounded-full"></div>
          <button onClick={handleClose} className="absolute top-1/2 -translate-y-1/2 right-0 p-4 ">
            <img src="/icons/close.svg" alt="close" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.getElementById('root'),
  );
}
